module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/messageforums/bravenet_messageforums_customizable_layouts.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/messageforums/bravenet_messageforums_customizable_layouts.png
// module id = CKDG
// module chunks = 0